import { useState, useEffect, useMemo } from 'react';
import { getDatabase, ref, get } from 'firebase/database';

/**
 * Project titles by key, for labelling delmoment outside the project board
 * (the Förvaltning board's "Delmoment · <projekt>" chip). Read-only, so it
 * reads Firebase directly; nothing is fetched until `enabled` is true.
 */
export function useProjectTitles(enabled: boolean): Map<string, string> {
    const [titles, setTitles] = useState<Record<string, string>>({});

    useEffect(() => {
        if (!enabled) return;
        let cancelled = false;
        get(ref(getDatabase(), 'projects'))
            .then(snapshot => {
                if (cancelled || !snapshot.exists()) return;
                const next: Record<string, string> = {};
                snapshot.forEach(child => {
                    const title = child.val()?.title;
                    if (child.key && typeof title === 'string') next[child.key] = title;
                });
                setTitles(next);
            })
            .catch(err => console.error('Error loading project titles:', err));
        return () => { cancelled = true; };
    }, [enabled]);

    return useMemo(() => new Map(Object.entries(titles)), [titles]);
}
